var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('nav',{staticClass:"list-group"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasPageMenu)?_c('div',{class:[
      'd-lg-none page-menu-container bg-menu',
      {
        'show': _vm.showPageMenu
      }
    ]},[_vm._t("page")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }